import { render, staticRenderFns } from "./CreateAddr.vue?vue&type=template&id=7b994adc&"
import script from "./CreateAddr.vue?vue&type=script&lang=js&"
export * from "./CreateAddr.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports